import { useSelector } from "react-redux";

export const useReadOnly = () =>
  useSelector((s) => s.Global.loggedUserDetails?.roleType === "custom");
